<template>
    <v-container>
        <v-layout row justify-space-around>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 xs11 elevation-6>
                <div class="sub-window">
                    <v-container pa-1 grid-list-md>
                        <!-- Encabezado con el título de la subventana y el botón para cerrarla: -->
                        <v-layout row justify-space-between>
                            <v-flex xs10 class="text-left">
                                <div class="text-left display-1 font-weight-bold teal--text text--lighten-2"
                                >{{ $t('title')}}</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon color="teal lighten-1">mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('btn-cerrar')}}</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider class="teal lighten-1"></v-divider>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-card class="mx-auto transparent" width="100%" elevation="0">
                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        <span v-html="$t('p1') "></span>
                                        <p></p>
                                        <span v-html="$t('p2') "></span>
                                    </v-card-text>

                                    <v-card-text class="subtitle-1 font-weight-bold teal--text text--lighten-2 text-sm-left">
                                        <span v-html="$t('subtitle1') "></span>
                                        <v-divider class="teal lighten-1"></v-divider>
                                    </v-card-text>

                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        <span v-html="$t('p3') "></span>
                                        <p></p>
                                        <span style="color:rgb(80, 203, 196);">
                                            <ul>
                                                <span v-html="$t('list1') "></span>
                                            </ul>
                                        </span>

                                    </v-card-text>

                                    <v-card-text class="subtitle-1 font-weight-bold teal--text text--lighten-2 text-sm-left">
                                        <span v-html="$t('subtitle2') "></span>
                                        <v-divider class="teal lighten-1"></v-divider>
                                    </v-card-text>

                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        <span v-html="$t('p4') "></span>
                                        <p></p>
                                        <span style="color:rgb(80, 203, 196);">
                                            <ul>
                                                <span v-html="$t('list2') "></span>
                                            </ul>
                                        </span>
                                    </v-card-text>

                                    <v-card-text class="subtitle-1 font-weight-bold teal--text text--lighten-2 text-sm-left">
                                        <span v-html="$t('subtitle3') "></span>
                                        <v-divider class="teal lighten-1"></v-divider>
                                    </v-card-text>

                                    <v-card-text class="teal--text text--lighten-5 text-sm-left">
                                        <span v-html="$t('p5') "></span>
                                        <p></p>
                                        <span style="color:rgb(80, 203, 196);">
                                            <ul>
                                                <span v-html="$t('list3') "></span>
                                            </ul>
                                        </span>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
    <!-- </v-card> -->
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'NuestrasHerramientasDx',
    data()
    {
        return {};
    },

    created() {},

    methods:
    {
        
        onClose()
        {
            this.showNuestrasHerramientasDxTx = false;
        }
    },

    computed:
    {
        ...mapGetters(['waitCursor']),

        showNuestrasHerramientasDxTx: {
            get()
            {
                return this.$store.getters.showNuestrasHerramientasDxTx;
            },
            set(showNuestrasHerramientasDxTx)
            {
                this.$store.dispatch('updateShowNuestrasHerramientasDxTx', showNuestrasHerramientasDxTx);
            }
        }
    }
};
</script>

<i18n>
{
    "es": {
        "title": "Nuestras herramientas de diagnóstico",
        "p1": "A principios del 2008 diseñamos <span style='color:rgb(80, 203, 196);'> <b>retroalimentame.com</b> </span> como una herramienta de apoyo a las organizaciones para sus procesos de retroalimentación 360˚ a ejecutivos. En estos más de 15 años, hemos complementado la oferta de valor de la página con una amplia variedad de servicios de diagnóstico.",
        "p2": "Todos nuestros diagnósticos se trabajan en línea por medio de contraseñas individuales o colectivas, conforme nuestros clientes decidan. Nuestra plataforma cubre con los más altos estándares de seguridad, puede ser accesada desde diferentes dispositivos móviles y no almacenamos ningún tipo de información para efectos operativos o de mercadotecnia.",
        "subtitle1": "Diagnósticos individuales",
        "p3": "Nuestros diagnósticos individuales están diseñados para fortalecer el liderazgo de los lideres de las organizaciones. Cubrimos una amplia gama de temas que muchas escuelas de negocio consideran importantes para fortalecer el desempeño de las organizaciones. Dentro de estos temas a diagnosticar se encuentran entre otros:",
        "list1": "<li>Inteligencia emocional basado en el modelo de Goleman</li><li>Liderazgo situacional basado en el modelo de Blanchard</li><li>Índice de determinación</li><li>Dar y recibir retroalimentación</li><li>Retroalimentación 360˚ de auto observación</li><li>Retroalimentación 360˚ con enfoque feedforward</li><li>Learning agility</li>",
        "subtitle2": "Diagnósticos de equipo",
        "p4": "La efectividad de los equipos de trabajo es, sin lugar a duda un tema donde las organizaciones invierten tiempo y recursos. Cada día más organizaciones están convencidas que conferencias motivacionales y actividades lúdicas no resuelven la problemática de integración de los equipos. <p></p>Se necesita trabajar en temas que varios autores han identificado a lo largo de muchos años, como los elementos que mejoran la efectividad de un equipo de trabajo y los ponen en camino hacía lo que muchos denominan el “alto desempeño”. La página ofrece un abanico de modelos de diagnóstico, entre otros se encuentran los siguientes:",
        "list2": "<li>El modelo desarrollado por Drexler y Sibbet</li><li>La evolución de equipos de Tuckman</li><li>El ambiente psicológicamente seguro</li><li>Las 5 disfunciones de Patrick Lencioni</li><li>Los roles de equipo basados en el modelo de Belbin</li><li>Resiliencia de equipos</li><li>Capacidades de ejecución de un equipo</li><li>Engagement</li><li>Elementos de permanencia y potencial rotación. Compensación integral</li><li>Empowerment</li><li>Habilidades de consultoría</li><li>Juntas efectivas de trabajo</li><li>Speed of Trust basado en el modelo de Covey</li>",
        "subtitle3": "Diagnósticos organizacionales",
        "p5": "<span style='color:rgb(80, 203, 196);'> <b>Retroalimentame.com</b> </span> tiene una página hermana para el levantamiento de encuestas masivas a nivel de toda la organización. <span style='color:rgb(80, 203, 196);'> <b>Efectividadorganizacional.com</b> </span> ofrece dentro de otros diagnósticos:",
        "list3": "<li>Elementos de total rewards</li><li>Cultura</li><ul><li>Actual</li><li>Deseada</li><li>Objetivo</li></ul><li>Clima organizacional con diferentes modelos</li><li>Varios modelos de engagement</li><li>Diversidad, Equidad e Inclusión</li>"
    },
    
    "en": {
        "title": "What do we evaluate?",
        "p1": "In early 2008 we designed <span style='color:rgb(80, 203, 196);'> <b>retroalimentame.com</b> </span> as a support tool for organizations for their self-observation, both for executives and for work teams.",
        "p2": "For some years, different authors have been working on the concept of emotional intelligence. All of them agree on the importance of self-observation as a first step, which allows the individual or a work team to become aware of the current situation and start working on the development of certain specific skills.",
        "subtitle1": "Diagnósticos individuales",
        "p3": "Nuestros diagnósticos individuales están diseñados para fortalecer el liderazgo de los lideres de las organizaciones. Cubrimos una amplia gama de temas que muchas escuelas de negocio consideran importantes para fortalecer el desempeño de las organizaciones. Dentro de estos temas a diagnosticar se encuentran entre otros:",
        "list1": "<li>Inteligencia emocional basado en el modelo de Goleman</li><li>Liderazgo situacional basado en el modelo de Blanchard</li><li>Índice de determinación</li><li>Dar y recibir retroalimentación</li><li>Retroalimentación 360˚ de auto observación</li><li>Retroalimentación 360˚ con enfoque feedforward</li><li>Learning agility</li>",
        "subtitle2": "Diagnósticos de equipo",
        "p4": "La efectividad de los equipos de trabajo es, sin lugar a duda un tema donde las organizaciones invierten tiempo y recursos. Cada día más organizaciones están convencidas que conferencias motivacionales y actividades lúdicas no resuelven la problemática de integración de los equipos. <p></p>Se necesita trabajar en temas que varios autores han identificado a lo largo de muchos años, como los elementos que mejoran la efectividad de un equipo de trabajo y los ponen en camino hacía lo que muchos denominan el “alto desempeño”. La página ofrece un abanico de modelos de diagnóstico, entre otros se encuentran los siguientes:",
        "list2": "<li>El modelo desarrollado por Drexler y Sibbet</li><li>La evolución de equipos de Tuckman</li><li>El ambiente psicológicamente seguro</li><li>Las 5 disfunciones de Patrick Lencioni</li><li>Los roles de equipo basados en el modelo de Belbin</li><li>Resiliencia de equipos</li><li>Capacidades de ejecución de un equipo</li><li>Engagement</li><li>Elementos de permanencia y potencial rotación. Compensación integral</li><li>Empowerment</li><li>Habilidades de consultoría</li><li>Juntas efectivas de trabajo</li><li>Speed of Trust basado en el modelo de Covey</li>",
        "subtitle3": "Diagnósticos organizacionales",
        "p5": "<span style='color:rgb(80, 203, 196);'> <b>Retroalimentame.com</b> </span> tiene una página hermana para el levantamiento de encuestas masivas a nivel de toda la organización. <span style='color:rgb(80, 203, 196);'> <b>Efectividadorganizacional.com</b> </span> ofrece dentro de otros diagnósticos:",
        "list3": "<li>Elementos de total rewards</li><li>Cultura</li><ul><li>Actual</li><li>Deseada</li><li>Objetivo</li></ul><li>Clima organizacional con diferentes modelos</li><li>Varios modelos de engagement</li><li>Diversidad, Equidad e Inclusión</li>"
    }
}
</i18n>

<style scoped>
.sub-window {
    /* background: rgba(0, 77, 64, 0.6); */
    background: rgba(26, 32, 38, 0.8);
}
</style>